import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../components/nav/crowpay.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  WordBreak_BreakAll_getInstance289x8dja79rdq as WordBreak_BreakAll_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { space2ppi73m2qk1br as space } from '../components/space.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  first58ocm7j58k3q as first,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { signOffHeader11hami6texki7 as signOffHeader } from '../components/signOffHeader.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../theming/states.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../theming/appTheme.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { FormMessage_getInstance34lpbvoeaecrx as FormMessage_getInstance } from '../theming/formThemes.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../components/iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { inlineLabel3artc1yn03kdr as inlineLabel } from '../components/keyValue.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../components/files/renderFiles.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  isUnread3o34h317z0nzb as isUnread,
  isUnread2u0ehyt0ioouz as isUnread_0,
} from '../../extensions/HasReadBy.ext.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredTextWithUnread1yfsy2lami2hh as specCenteredTextWithUnread,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
} from '../screens/common/DialogWithDialog.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  ProjectRouter1ifo7nf2si2jf as ProjectRouter,
  ProjectView3mpzjwcpohxct as ProjectView,
  Buttons_instancevdnfm4kr7aly as Buttons_instance,
} from '../screens/common/ProjectView.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../utils/JumpTo.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  overallStatus206eg9g5yqouc as overallStatus,
  get_individualStatus1waisigfu538t as get_individualStatus,
} from '../components/project/work/payApps/data.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  ChangeRequestItem25pmay5za3qvv as ChangeRequestItem,
  Creditv1m3yq08fl3i as Credit,
  Manual3lg0s0ycvhhh4 as Manual,
  CompletionRequest2ew7c02dda2ep as CompletionRequest,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../sdk/errors.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  MessageDatalcsuuwceag9q as MessageData,
  ManualStatewy76bep9f2j as ManualState,
} from '../components/project/activity/concerns/ConcernCardInfo.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_status1d77371nrw24k as get_status_0,
  ChangeItemReadReceipts_instance2jo5uerda8tke as ChangeItemReadReceipts_instance,
} from '../components/project/work/changeOrders/data.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_timestampsmki8tl7yqiq as get_timestamp,
  get_projectCreditGroupjukbcz0r5fa1 as get_projectCreditGroup,
} from '../../../../../crowpay-shared/com/crowpay/CreditFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  ProjectState_RequestingComplete_getInstance29ba44myrjzuw as ProjectState_RequestingComplete_getInstance,
} from '../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  raiseIssueAtFinalCompletionodlw1oct00lk as raiseIssueAtFinalCompletion,
  acceptFinalCompletion1zm28w35ed7aq as acceptFinalCompletion,
} from '../components/project/actionBar.mjs';
import { button2ojurxuym14mn as button } from '../../utils/ButtonAction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.si4_1.bi5($this.si4_1.ui4_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.also' call
    var this_0 = $this.ti4_1;
    onRemove(this_0, tmp0_safe_receiver);
  }
  return Unit_instance;
}
function _get_outerPadding__4anaiz($this, _this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? null : get_AppDimensions().yg1_1;
}
function outerPadding($this, _this__u8e3s4) {
  var tmp0_safe_receiver = _get_outerPadding__4anaiz($this, _this__u8e3s4);
  var tmp = tmp0_safe_receiver;
  if ((tmp == null ? null : new (Dimension())(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp0_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new (Dimension())(tmp_0)).yb1_1;
    space(_this__u8e3s4, it);
  }
}
function closeForm($this, _this__u8e3s4) {
  get_dialogStack().wgg();
  if (lastOrNull(get_mainPageNavigator(_this__u8e3s4).ibn_1.f2()) === $this) {
    get_mainPageNavigator(_this__u8e3s4).td6();
  }
}
function get_files() {
  return null;
}
var MessageClass;
function Message() {
  if (MessageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Message');
    MessageClass = $;
  }
  return MessageClass;
}
function page($this, _this__u8e3s4, renderingAsDialog) {
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var $this$col = view;
  $this$col.bb9(get_px(0));
  var tmp0_safe_receiver = $this.ai5_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    if (renderingAsDialog) {
      tmp_0 = () => {
        closeForm($this, $this$col);
        return Unit_instance;
      };
    } else {
      tmp_0 = null;
    }
    signOffHeader($this$col, tmp0_safe_receiver, 'Decisions in this section may release escrow funds.', tmp_0);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_px(0));
  outerPadding($this, view_0);
  var tmp_1 = view_0.kbb(view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5)), get_expanding(view_0)), view_0.jbb(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.lbb(view_1.kbb(view_1.kbb(get_expanding(view_1), get_centered(view_1)), view_1.jbb(DisplayableStateSemantic().ogt($this.wi4_1))), text(view_1, $this.wi4_1.e90()));
  var tmp_2 = view_1.kbb(view_1.kbb(get_centered(view_1), sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(7))), get_compact(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(true);
  view_2.bb9(get_dp(2));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = format($this.xi4_1, Formats_getInstance().h8z_1);
  var tmp_3 = view_3.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = value;
  }
  tmp_3.hbu(tmp_4);
  view_2.hbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_4.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = format($this.xi4_1, Formats_getInstance().j8z_1);
  var tmp_5 = view_4.vb5_1;
  var tmp_6;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_6 = '\xA0';
  } else {
    tmp_6 = value_0;
  }
  tmp_5.hbu(tmp_6);
  view_2.hbb(p_4, view_4);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_2, view_2);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_1, view_1);
  outerPadding($this, view_0);
  $this$col.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Separator())($this$col.pc());
  var tmp0_elvis_lhs_5 = $this$col.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? $this$col : tmp0_elvis_lhs_5;
  $this$col.gbb(p_5, view_5);
  $this$col.hbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_6 = $this$col.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? $this$col : tmp0_elvis_lhs_6;
  $this$col.gbb(p_6, view_6);
  view_6.zbm(false);
  view_6.bb9(get_px(0));
  outerPadding($this, view_6);
  var tmp_7 = get_expanding(view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  view_7.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Space())(view_7.pc(), 0.15);
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  view_7.hbb(p_8, view_8);
  view_7.bb9(get_AppDimensions().bg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_9 = view_7.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
  view_7.gbb(p_9, view_9);
  view_9.zbm(true);
  view_9.bb9(get_rem_0(0.5));
  $this.ci5(view_9);
  greySeparator(view_9);
  view_7.hbb(p_9, view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_10 = view_7.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
  view_7.gbb(p_10, view_10);
  view_10.zbm(true);
  var tmp_8 = get_outlined(view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Frame())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (RowOrCol())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.gbb(p_12, view_12);
  view_12.zbm(true);
  view_12.bb9(get_px(0));
  boldSubTitle(view_12, 'History');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_12.pc());
  var tmp0_elvis_lhs_13 = view_12.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
  view_12.gbb(p_13, view_13);
  view_13.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (Space())(view_13.pc(), 0.0);
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_13.hbb(p_14, view_14);
  launch(view_13, VOID, VOID, BasicFlowForm$page$slambda_0($this, view_13));
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.ui4_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$37 = $this.di5(item);
    destination.v(tmp$ret$37);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_9 = BasicFlowForm$page$lambda;
  var tmp$ret$40 = new (sam$kotlin_Comparator$0())(tmp_9);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = sortedWith(destination, tmp$ret$40).m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp_10 = view_13.jbb(FormMessage_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_15 = new (RowOrCol())(view_13.pc());
    var tmp0_elvis_lhs_15 = view_13.ebb_1;
    var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
    view_13.gbb(p_15, view_15);
    view_15.zbm(true);
    var unread = remember(VOID, VOID, VOID, BasicFlowForm$page$lambda_0(element));
    view_15.bb9(get_dp(0));
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var tmp$ret$42 = view_15.jbb(CardSemantic_getInstance());
    var tmp_11 = view_15.kbb(tmp$ret$42, view_15.jbb(DisplayableStateSemantic().ogt(element.mfy()).abf(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_16 = new (Frame())(view_15.pc());
    var tmp0_elvis_lhs_16 = view_15.ebb_1;
    var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
    view_15.gbb(p_16, view_16);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_17 = new (RowOrCol())(view_16.pc());
    var tmp0_elvis_lhs_17 = view_16.ebb_1;
    var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
    view_16.gbb(p_17, view_17);
    view_17.zbm(false);
    view_17.bb9(get_AppDimensions().og2_1);
    get_centered(view_17);
    unreadIconWhen(view_17, BasicFlowForm$page$lambda_1(unread));
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance();
    body(view_17, element.mfy().e90());
    view_16.hbb(p_17, view_17);
    view_15.hbb(p_16, view_16);
    view_15.lbb(tmp_11, view_16);
    var tmp_12 = get_padded(view_15);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_18 = new (RowOrCol())(view_15.pc());
    var tmp0_elvis_lhs_18 = view_15.ebb_1;
    var p_18 = tmp0_elvis_lhs_18 == null ? view_15 : tmp0_elvis_lhs_18;
    view_15.gbb(p_18, view_18);
    view_18.zbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_19 = new (RowOrCol())(view_18.pc());
    var tmp0_elvis_lhs_19 = view_18.ebb_1;
    var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
    view_18.gbb(p_19, view_19);
    view_19.zbm(false);
    view_19.lbb(get_centered(view_19), bodyBold(view_19, element.i94() ? $this.yi4_1 : $this.zi4_1));
    view_19.lbb(get_centered(view_19), smallBody(view_19, format(element.k94(), Formats_getInstance().i8z_1)));
    view_18.hbb(p_19, view_19);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_20 = new (TextView())(view_18.pc());
    var tmp0_elvis_lhs_20 = view_18.ebb_1;
    var p_20 = tmp0_elvis_lhs_20 == null ? view_18 : tmp0_elvis_lhs_20;
    view_18.gbb(p_20, view_20);
    view_20.lba(view_20.qb6_1.abf(BodySemantic_getInstance()));
    view_20.bcp(WordBreak_BreakAll_getInstance());
    inlineLabel(view_20, element.h94().e90(), element.j());
    view_18.hbb(p_20, view_20);
    var tmp0_safe_receiver_0 = element.t91();
    var tmp_13;
    if (tmp0_safe_receiver_0 == null) {
      tmp_13 = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_14;
      if (!tmp0_safe_receiver_0.i1()) {
        tmp_14 = tmp0_safe_receiver_0;
      } else {
        tmp_14 = null;
      }
      tmp_13 = tmp_14;
    }
    var tmp1_safe_receiver = tmp_13;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      renderFiles(view_18, new (Constant())(_Constant___init__impl__v45mub(tmp1_safe_receiver)), get_rem(5));
    }
    view_15.hbb(p_18, view_18);
    view_15.lbb(tmp_12, view_18);
    view_13.hbb(p_15, view_15);
    view_13.lbb(tmp_10, view_15);
  }
  view_12.hbb(p_13, view_13);
  view_11.hbb(p_12, view_12);
  view_10.hbb(p_11, view_11);
  view_10.lbb(tmp_8, view_11);
  view_7.hbb(p_10, view_10);
  $this.ei5(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (Space())(view_7.pc(), 0.15);
  var tmp0_elvis_lhs_21 = view_7.ebb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_7 : tmp0_elvis_lhs_21;
  view_7.gbb(p_21, view_21);
  view_7.hbb(p_21, view_21);
  view_6.hbb(p_7, view_7);
  view_6.lbb(tmp_7, view_7);
  outerPadding($this, view_6);
  $this$col.hbb(p_6, view_6);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.fi5_1 = function_0;
      }
      wi(a, b) {
        return this.fi5_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.fi5_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var BasicFlowForm$withState$1Class;
function BasicFlowForm$withState$1() {
  if (BasicFlowForm$withState$1Class === VOID) {
    class $ {
      constructor($this_withState, $state) {
        this.gi5_1 = $this_withState;
        this.hi5_1 = $state;
      }
      mfy() {
        return this.hi5_1;
      }
      h94() {
        return this.gi5_1.h94();
      }
      j() {
        return this.gi5_1.j();
      }
      i94() {
        return this.gi5_1.i94();
      }
      j94() {
        return this.gi5_1.j94();
      }
      k94() {
        return this.gi5_1.k94();
      }
      v91() {
        return this.gi5_1.v91();
      }
    }
    protoOf($).t91 = get_files;
    initMetadataForClass($, VOID, VOID, VOID, [Message()]);
    BasicFlowForm$withState$1Class = $;
  }
  return BasicFlowForm$withState$1Class;
}
var BasicFlowForm$withFiles$1Class;
function BasicFlowForm$withFiles$1() {
  if (BasicFlowForm$withFiles$1Class === VOID) {
    class $ {
      constructor($this_withFiles, $files) {
        this.ii5_1 = $this_withFiles;
        this.ji5_1 = $files;
      }
      t91() {
        return this.ji5_1;
      }
      mfy() {
        return this.ii5_1.mfy();
      }
      h94() {
        return this.ii5_1.h94();
      }
      j() {
        return this.ii5_1.j();
      }
      i94() {
        return this.ii5_1.i94();
      }
      j94() {
        return this.ii5_1.j94();
      }
      k94() {
        return this.ii5_1.k94();
      }
      v91() {
        return this.ii5_1.v91();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Message()]);
    BasicFlowForm$withFiles$1Class = $;
  }
  return BasicFlowForm$withFiles$1Class;
}
var BasicFlowForm$page$slambdaClass;
function BasicFlowForm$page$slambda() {
  if (BasicFlowForm$page$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$scope) {
        this.si4_1 = this$0;
        this.ti4_1 = $$this$scope;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    BasicFlowForm$page$slambdaClass = $;
  }
  return BasicFlowForm$page$slambdaClass;
}
function BasicFlowForm$page$slambda_0(this$0, $$this$scope) {
  var i = new (BasicFlowForm$page$slambda())(this$0, $$this$scope);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function BasicFlowForm$page$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.k94();
  var tmp$ret$1 = b.k94();
  return compareValues(tmp, tmp$ret$1);
}
function BasicFlowForm$page$lambda_0($message) {
  return ($this$remember) => isUnread($message.v91(), $this$remember.daj(get_session()).gfv_1);
}
function BasicFlowForm$page$lambda_1($unread) {
  return ($this$unreadIconWhen) => $this$unreadIconWhen.daj($unread);
}
var BasicFlowForm$goBackButton$slambdaClass;
function BasicFlowForm$goBackButton$slambda() {
  if (BasicFlowForm$goBackButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.ki5_1 = this$0;
        this.li5_1 = $$this$button;
      }
      uao($completion) {
        closeForm(this.ki5_1, this.li5_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BasicFlowForm$goBackButton$slambdaClass = $;
  }
  return BasicFlowForm$goBackButton$slambdaClass;
}
function BasicFlowForm$goBackButton$slambda_0(this$0, $$this$button) {
  var i = new (BasicFlowForm$goBackButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var BasicFlowForm$renderAsDialog$slambdaClass;
function BasicFlowForm$renderAsDialog$slambda() {
  if (BasicFlowForm$renderAsDialog$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground) {
        this.mi5_1 = this$0;
        this.ni5_1 = $$this$dismissBackground;
      }
      uao($completion) {
        closeForm(this.mi5_1, this.ni5_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BasicFlowForm$renderAsDialog$slambdaClass = $;
  }
  return BasicFlowForm$renderAsDialog$slambdaClass;
}
function BasicFlowForm$renderAsDialog$slambda_0(this$0, $$this$dismissBackground) {
  var i = new (BasicFlowForm$renderAsDialog$slambda())(this$0, $$this$dismissBackground);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var BasicFlowFormClass;
function BasicFlowForm() {
  if (BasicFlowFormClass === VOID) {
    class $ {
      constructor(items, formTitle, formState, created, clientName, contractorName, greyHeader) {
        greyHeader = greyHeader === VOID ? null : greyHeader;
        this.ui4_1 = items;
        this.vi4_1 = formTitle;
        this.wi4_1 = formState;
        this.xi4_1 = created;
        this.yi4_1 = clientName;
        this.zi4_1 = contractorName;
        this.ai5_1 = greyHeader;
      }
      oi5(_this__u8e3s4, state) {
        return new (BasicFlowForm$withState$1())(_this__u8e3s4, state);
      }
      pi5(_this__u8e3s4, files) {
        return new (BasicFlowForm$withFiles$1())(_this__u8e3s4, files);
      }
      qi5(_this__u8e3s4) {
        var tmp = get_textButton(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        specCenteredText(view, 'Go Back');
        onClick(view, VOID, VOID, BasicFlowForm$goBackButton$slambda_0(this, view));
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      ei5(_this__u8e3s4) {
        return _this__u8e3s4.lbb(get_atEnd(_this__u8e3s4), this.qi5(_this__u8e3s4));
      }
      ygs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp0_vertical = get_px(0);
        var tmp1_horizontal = get_AppDimensions().yg1_1;
        view.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
        view.vbo(BasicFlowForm$renderAsDialog$slambda_0(this, view));
        var tmp_0 = get_atTopCenter(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.jba(Edges().cd0(get_px(0)).id0(VOID, get_rem(3), VOID, get_rem(5)));
        view_0.eb9(true);
        view_0.lbb(view_0.kbb(view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1), get_atTopCenter(view_0)), view_0.jbb(DialogSemantic_getInstance())), page(this, view_0, true));
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      xgs(_this__u8e3s4) {
        return _this__u8e3s4.lbb(get_scrolling(_this__u8e3s4), page(this, _this__u8e3s4, false));
      }
    }
    protoOf($).wcv = get_title;
    protoOf($).wd6 = render;
    initMetadataForClass($, 'BasicFlowForm', VOID, VOID, [Page(), DialogOrPage()], [1]);
    BasicFlowFormClass = $;
  }
  return BasicFlowFormClass;
}
function *_generator_markAsReadDelayUpdate__jx65oj($this, items, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfw_1.wft(items, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    tmp_1 = () => {
      println('updating');
      it();
      return Unit_instance;
    };
  }
  return tmp_1;
}
var DrawWaitedDetails$header$slambdaClass;
function DrawWaitedDetails$header$slambda() {
  if (DrawWaitedDetails$header$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ri5_1 = $$this$button;
        this.si5_1 = this$0;
      }
      uao($completion) {
        // Inline function 'kotlin.run' call
        var $this$run = get_mainPageNavigator(this.ri5_1);
        var tmp = lastOrNull($this$run.ibn_1.f2());
        if (!(tmp instanceof ProjectView())) {
          $this$run.fbw(new (ProjectRouter())(this.si5_1.ai6_1.h6y_1));
        }
        JumpTo_getInstance().vg3_1.bg5(this.si5_1.ai6_1.g6y_1, VOID, VOID, false);
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DrawWaitedDetails$header$slambdaClass = $;
  }
  return DrawWaitedDetails$header$slambdaClass;
}
function DrawWaitedDetails$header$slambda_0($$this$button, this$0) {
  var i = new (DrawWaitedDetails$header$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DrawWaitedDetailsClass;
function DrawWaitedDetails() {
  if (DrawWaitedDetailsClass === VOID) {
    class $ extends BasicFlowForm() {
      constructor(payApp, allItems, lines, clientName, contractorName) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = allItems.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!(element.t6v_1 == null)) {
            destination.v(element);
          }
        }
        var tmp = destination;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().u(collectionSizeOrDefault(allItems, 10));
        var _iterator__ex2g4s_0 = allItems.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$3 = get_status(item);
          destination_0.v(tmp$ret$3);
        }
        var tmp_0 = overallStatus(toSet(destination_0));
        var tmp0_elvis_lhs = payApp.k6y_1;
        super(tmp, 'Draw Waited', tmp_0, tmp0_elvis_lhs == null ? payApp.j6y_1 : tmp0_elvis_lhs, clientName, contractorName);
        this.ai6_1 = payApp;
        this.bi6_1 = allItems;
        this.ci6_1 = lines;
      }
      wcv() {
        return new (Constant())(_Constant___init__impl__v45mub('Draw Waited'));
      }
      ci5(_this__u8e3s4) {
        var unread = remember(VOID, VOID, VOID, ($this$remember) => isUnread_0(this.ai6_1, $this$remember.daj(get_session()).gfv_1));
        bodyBold(_this__u8e3s4, 'Draw');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        var tmp = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        var tmp_0 = view_0.kbb(get_expanding(view_0), get_centered(view_0));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Draw ' + this.ai6_1.i6y_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_1 = view_1.vb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = content;
        }
        tmp_1.hbu(tmp_2);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        var tmp_3 = get_centered(view_0);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = this.bi6_1;
        var sum = Companion_instance.r91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_4 = sum;
          var tmp$ret$6 = element.r6v_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_4, tmp$ret$6);
        }
        var tmp$ret$7 = sum;
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = MonetaryValue__toString_impl_xslc77(tmp$ret$7);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_5 = view_2.vb5_1;
        var tmp_6;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_6 = '\xA0';
        } else {
          tmp_6 = content_0;
        }
        tmp_5.hbu(tmp_6);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp_3, view_2);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_7 = view.kbb(get_centered(view), get_secondaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        specCenteredTextWithUnread(view_3, 'View Draw', ($this$specCenteredTextWithUnread) => $this$specCenteredTextWithUnread.daj(unread));
        onClick(view_3, 'View Item', VOID, DrawWaitedDetails$header$slambda_0(view_3, this));
        view.hbb(p_3, view_3);
        view.lbb(tmp_7, view_3);
        _this__u8e3s4.hbb(p, view);
      }
      di6(item) {
        var tmp0_elvis_lhs = this.ci6_1.p3(item.q6v_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NotFound().pfx(getKClass(LineItem()), null);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return this.oi5(MessageData().lgp(item, tmp, this.ai6_1.i6y_1), get_individualStatus(item));
      }
      di5(item) {
        return this.di6(item instanceof PayAppItem() ? item : THROW_CCE());
      }
      ei6(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsReadDelayUpdate__jx65oj.bind(VOID, this, items), $completion);
      }
      bi5(items, $completion) {
        return this.ei6(items, $completion);
      }
    }
    initMetadataForClass($, 'DrawWaitedDetails', VOID, VOID, VOID, [1]);
    DrawWaitedDetailsClass = $;
  }
  return DrawWaitedDetailsClass;
}
var ChangesRejectedDetails$header$slambdaClass;
function ChangesRejectedDetails$header$slambda() {
  if (ChangesRejectedDetails$header$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.fi6_1 = $$this$button;
        this.gi6_1 = this$0;
      }
      uao($completion) {
        // Inline function 'kotlin.run' call
        var $this$run = get_mainPageNavigator(this.fi6_1);
        var tmp = lastOrNull($this$run.ibn_1.f2());
        if (!(tmp instanceof ProjectView())) {
          $this$run.fbw(new (ProjectRouter())(this.gi6_1.oi6_1.p57_1));
        }
        JumpTo_getInstance().pg3_1.bg5(first(this.gi6_1.ui4_1).f40(), VOID, VOID, false);
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangesRejectedDetails$header$slambdaClass = $;
  }
  return ChangesRejectedDetails$header$slambdaClass;
}
function ChangesRejectedDetails$header$slambda_0($$this$button, this$0) {
  var i = new (ChangesRejectedDetails$header$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangesRejectedDetailsClass;
function ChangesRejectedDetails() {
  if (ChangesRejectedDetailsClass === VOID) {
    class $ extends BasicFlowForm() {
      constructor(change, allItems, clientName, contractorName) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = allItems.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!(element.a95() == null)) {
            destination.v(element);
          }
        }
        var tmp = destination;
        // Inline function 'kotlin.collections.maxOf' call
        var iterator = allItems.m1();
        if (!iterator.n1())
          throw NoSuchElementException().y1();
        var it = iterator.o1();
        var maxValue = get_status_0(it);
        while (iterator.n1()) {
          var it_0 = iterator.o1();
          var v = get_status_0(it_0);
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        super(tmp, 'Change Rejected', maxValue, change.a58_1, clientName, contractorName);
        this.oi6_1 = change;
        this.pi6_1 = allItems;
      }
      wcv() {
        return new (Constant())(_Constant___init__impl__v45mub('Change Rejected'));
      }
      ci5(_this__u8e3s4) {
        var unread = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (isUnread_0(this.oi6_1, $this$remember.daj(get_session()).gfv_1)) {
            tmp = true;
          } else {
            var tmp0 = this.pi6_1;
            var tmp$ret$0;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_0;
              if (isInterface(tmp0, Collection())) {
                tmp_0 = tmp0.i1();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (isUnread(element.v91(), $this$remember.daj(get_session()).gfv_1)) {
                  tmp$ret$0 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$0 = false;
            }
            tmp = tmp$ret$0;
          }
          return tmp;
        });
        bodyBold(_this__u8e3s4, 'Change');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        var tmp = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        var tmp_0 = view_0.kbb(get_expanding(view_0), get_centered(view_0));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Change ' + this.oi6_1.z57_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_1 = view_1.vb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = content;
        }
        tmp_1.hbu(tmp_2);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        var tmp_3 = get_centered(view_0);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = this.pi6_1;
        var sum = Companion_instance.r91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_4 = sum;
          var tmp0_elvis_lhs_2 = element.w94();
          var tmp_5;
          var tmp_6 = tmp0_elvis_lhs_2;
          if ((tmp_6 == null ? null : new (MonetaryValue())(tmp_6)) == null) {
            tmp_5 = Companion_instance.r91(0n);
          } else {
            tmp_5 = tmp0_elvis_lhs_2;
          }
          var tmp$ret$8 = tmp_5;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_4, tmp$ret$8);
        }
        var tmp$ret$9 = sum;
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = MonetaryValue__toString_impl_xslc77(tmp$ret$9);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_7 = view_2.vb5_1;
        var tmp_8;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_8 = '\xA0';
        } else {
          tmp_8 = content_0;
        }
        tmp_7.hbu(tmp_8);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp_3, view_2);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_9 = view.kbb(get_centered(view), get_secondaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view.pc());
        var tmp0_elvis_lhs_4 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
        view.gbb(p_3, view_3);
        specCenteredTextWithUnread(view_3, 'View Change', ($this$specCenteredTextWithUnread) => $this$specCenteredTextWithUnread.daj(unread));
        onClick(view_3, 'View Item', VOID, ChangesRejectedDetails$header$slambda_0(view_3, this));
        view.hbb(p_3, view_3);
        view.lbb(tmp_9, view_3);
        _this__u8e3s4.hbb(p, view);
      }
      qi6(item) {
        return this.oi5(MessageData().ngp(item), get_status_0(item));
      }
      di5(item) {
        return this.qi6((!(item == null) ? isInterface(item, ChangeRequestItem()) : false) ? item : THROW_CCE());
      }
      ri6(items, $completion) {
        return ChangeItemReadReceipts_instance.uh8(items, $completion);
      }
      bi5(items, $completion) {
        return this.ri6(items, $completion);
      }
    }
    initMetadataForClass($, 'ChangesRejectedDetails', VOID, VOID, VOID, [1]);
    ChangesRejectedDetailsClass = $;
  }
  return ChangesRejectedDetailsClass;
}
function *_generator_markAsReadDelayUpdate__jx65oj_0($this, items, $completion) {
  var tmp;
  if ($this.ei7_1 == null) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = tmp_0.rfv_1;
    var tmp_2 = setOf($this.di7_1);
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_3 = serializerOrContextual(createKType(getKClass(Credit()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$1);
    var tmp$ret$5 = eq(get_projectCreditGroup(it), $this.zi6_1.c5r_1);
    var tmp_4 = tmp_1.kfu(tmp_2, tmp$ret$5, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_5 = await_0(this_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var tmp_6 = tmp_5.ofv_1;
    var tmp_7 = setOf($this.ei7_1);
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_8 = serializerOrContextual(createKType(getKClass(Credit()), arrayOf([]), false));
    var tmp$ret$7 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it_0 = new (DataClassPathSelf())(tmp$ret$7);
    var tmp$ret$11 = eq(get_timestamp(it_0), $this.zi6_1.z5q_1);
    var tmp_9 = tmp_6.kfu(tmp_7, tmp$ret$11, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    tmp = tmp_9;
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.uhj_1 = new (ManualState())('Issued', AppColors_getInstance().ffz_1.zg9_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var CreditDetailsClass;
function CreditDetails() {
  if (CreditDetailsClass === VOID) {
    class $ extends BasicFlowForm() {
      constructor(credit, client, contractor, userId, project, lineItem) {
        Companion_getInstance_0();
        super(listOf(credit), lineItem == null ? 'Project Credit' : 'Work Item Credit', Companion_getInstance_0().uhj_1, credit.z5q_1, client.d5c_1, contractor.v5i_1);
        this.zi6_1 = credit;
        this.ai7_1 = client;
        this.bi7_1 = contractor;
        this.ci7_1 = userId;
        this.di7_1 = project;
        this.ei7_1 = lineItem;
      }
      wcv() {
        return new (Constant())(_Constant___init__impl__v45mub(this.vi4_1));
      }
      fi7(item) {
        return this.oi5(MessageData().rgp(item.d5r_1, false, item.z5q_1, this.bi7_1.t5i_1, new (Manual())(this.vi4_1 + ', ' + MonetaryValue__toString_impl_xslc77(item.y5q_1)), this.zi6_1.e5r_1), Companion_getInstance_0().uhj_1);
      }
      di5(item) {
        return this.fi7(item instanceof Credit() ? item : THROW_CCE());
      }
      gi7(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsReadDelayUpdate__jx65oj_0.bind(VOID, this, items), $completion);
      }
      bi5(items, $completion) {
        return this.gi7(items, $completion);
      }
      ci5(_this__u8e3s4) {
        bodyBold(_this__u8e3s4, 'Credit');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        var tmp = view.kbb(get_expanding(view), get_centered(view));
        var tmp0_safe_receiver = this.ei7_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w91();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          var tmp2_elvis_lhs = this.zi6_1.c5r_1;
          tmp_0 = 'Credit ' + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = tmp_0;
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_1 = view_0.vb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = content;
        }
        tmp_1.hbu(tmp_2);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_3 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = MonetaryValue__toString_impl_xslc77(this.zi6_1.y5q_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_4 = view_1.vb5_1;
        var tmp_5;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_5 = '\xA0';
        } else {
          tmp_5 = content_0;
        }
        tmp_4.hbu(tmp_5);
        view.hbb(p_1, view_1);
        view.lbb(tmp_3, view_1);
        _this__u8e3s4.hbb(p, view);
      }
    }
    initMetadataForClass($, 'CreditDetails', VOID, VOID, VOID, [1]);
    CreditDetailsClass = $;
  }
  return CreditDetailsClass;
}
var ProjectCompleteRequestDetailsClass;
function ProjectCompleteRequestDetails() {
  if (ProjectCompleteRequestDetailsClass === VOID) {
    class $ extends BasicFlowForm() {
      constructor(project, request, lens, clientName, contractorName, data) {
        var tmp = request.x5f(VOID, VOID, VOID, null);
        // Inline function 'kotlin.takeIf' call
        var tmp_0;
        if (!(request.u5f_1 == null)) {
          tmp_0 = request;
        } else {
          tmp_0 = null;
        }
        var tmp$ret$1 = tmp_0;
        var tmp_1 = listOfNotNull([tmp, tmp$ret$1]);
        var tmp_2;
        var tmp0_safe_receiver = project.s7b_1;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u5f_1) == null)) {
          tmp_2 = null;
        } else {
          if (lens.zgj()) {
            tmp_2 = 'SIGN-OFF REVIEW';
          } else {
            tmp_2 = 'SIGN-OFF REQUEST';
          }
        }
        super(tmp_1, 'Project', project.u7b_1, request.r5f_1.o54_1, clientName, contractorName, tmp_2);
        this.oi7_1 = project;
        this.pi7_1 = request;
        this.qi7_1 = lens;
        this.ri7_1 = data;
      }
      wcv() {
        return new (Constant())(_Constant___init__impl__v45mub('Complete Project'));
      }
      ci5(_this__u8e3s4) {
        bodyBold(_this__u8e3s4, 'Project');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        var tmp = view.kbb(get_expanding(view), get_centered(view));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = this.oi7_1.b7b_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_0 = view_0.vb5_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = content;
        }
        tmp_0.hbu(tmp_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_2 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = MonetaryValue__toString_impl_xslc77(this.oi7_1.w7b_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_3 = view_1.vb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = content_0;
        }
        tmp_3.hbu(tmp_4);
        view.hbb(p_1, view_1);
        view.lbb(tmp_2, view_1);
        _this__u8e3s4.hbb(p, view);
      }
      si7(item) {
        var tmp0_safe_receiver = item.u5f_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.oi5(MessageData().rgp('', true, tmp0_safe_receiver.o54_1, tmp0_safe_receiver.k54_1, new (Manual())(!(this.oi7_1.h7b_1 == null) ? 'Accept & Pay Retention' : 'Accept Final Completion'), emptySet()), ProjectState_Complete_getInstance());
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.pi5(this.oi5(MessageData().rgp(item.s5f_1, false, item.r5f_1.o54_1, item.r5f_1.k54_1, new (Manual())('Request Final Completion'), emptySet()), ProjectState_RequestingComplete_getInstance()), item.t5f_1) : tmp1_elvis_lhs;
      }
      di5(item) {
        return this.si7(item instanceof CompletionRequest() ? item : THROW_CCE());
      }
      ti7(items, $completion) {
        return null;
      }
      bi5(items, $completion) {
        return this.ti7(items, $completion);
      }
      ei5(_this__u8e3s4) {
        var tmp;
        var tmp_0;
        var tmp0_safe_receiver = this.oi7_1.s7b_1;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u5f_1) == null)) {
          tmp_0 = true;
        } else {
          tmp_0 = !this.qi7_1.zgj();
        }
        if (tmp_0) {
          tmp = _this__u8e3s4.lbb(get_atEnd(_this__u8e3s4), this.qi5(_this__u8e3s4));
        } else {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.gbb(p, view);
          view.zbm(false);
          if (get_viewIsWide(view)) {
            this.qi5(view);
            var tmp_1 = get_expanding(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.space' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Space())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            view.hbb(p_0, view_0);
            view.lbb(tmp_1, view_0);
            view.lbb(get_centered(view), button(view, raiseIssueAtFinalCompletion(Buttons_instance, this.oi7_1, this.qi7_1)));
            view.lbb(get_centered(view), button(view, acceptFinalCompletion(Buttons_instance, this.ri7_1, view)));
          } else {
            view.lbb(view.kbb(get_expanding(view), get_centered(view)), this.qi5(view));
            view.lbb(view.kbb(get_expanding(view), get_centered(view)), button(view, raiseIssueAtFinalCompletion(Buttons_instance, this.oi7_1, this.qi7_1), false));
            view.lbb(view.kbb(get_expanding(view), get_centered(view)), button(view, acceptFinalCompletion(Buttons_instance, this.ri7_1, view), false));
          }
          _this__u8e3s4.hbb(p, view);
          tmp = view;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ProjectCompleteRequestDetails', VOID, VOID, VOID, [1]);
    ProjectCompleteRequestDetailsClass = $;
  }
  return ProjectCompleteRequestDetailsClass;
}
//region block: exports
export {
  ChangesRejectedDetails as ChangesRejectedDetails1h1y23it63u9u,
  CreditDetails as CreditDetails2g0vi8qhuk0sb,
  DrawWaitedDetails as DrawWaitedDetails301fxrq4n3zo5,
  ProjectCompleteRequestDetails as ProjectCompleteRequestDetails1r4j7qa671vek,
  Companion_getInstance_0 as Companion_getInstance3052zauf3vwf2,
};
//endregion

//# sourceMappingURL=BasicFlowForms.mjs.map
